// A RenderedValue is a value that should be displayed in a different way than it should be selected
interface RenderedValue {
  value: string;
  label: string;
}

export function isRenderedValue(o: any): o is RenderedValue {
  if (o === undefined || o === null) {
    return false;
  }

  if (typeof o !== "object") {
    return false;
  }

  const keys = Object.keys(o);
  if (keys.includes("value") && keys.includes("label") && keys.length === 2) {
    return true;
  } else {
    return false;
  }
}

export type RenderableValue = RenderedValue | string;

export namespace RVUtils {
  export function value(v: RenderableValue): string {
    if (isRenderedValue(v)) {
      return v.value;
    } else {
      return v;
    }
  }

  export function label(v: RenderableValue): string {
    if (isRenderedValue(v)) {
      return v.label;
    } else {
      return v;
    }
  }
}
